import { render, staticRenderFns } from "./ApprovalStats.vue?vue&type=template&id=0b1ef63e&scoped=true"
import script from "./ApprovalStats.vue?vue&type=script&lang=js"
export * from "./ApprovalStats.vue?vue&type=script&lang=js"
import style0 from "./ApprovalStats.vue?vue&type=style&index=0&id=0b1ef63e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1ef63e",
  null
  
)

export default component.exports